type EmptyCheckValue = string | null | undefined | object;

const isEmpty = (value: EmptyCheckValue): boolean =>
     value === undefined ||
     value === null ||
     value === "null" ||
     (typeof value === "object" && value !== null && !Array.isArray(value) && Object.keys(value)?.length === 0) ||
     (typeof value === "string" && value?.trim()?.length === 0);

export default isEmpty;
